export default function UnauthorizedPage() {
  return (
    <div style={{ padding: 40 }}>
      <h1>Unauthorized</h1>
      <p>You do not have permission to access this page.</p>
      <a href="/login">Go to login</a>
    </div>
  );
}
